module.exports = __webpack_public_path__ + "img/boiler-change.86342ff8.webp";